import {Component, OnDestroy, OnInit} from '@angular/core';
import {DialogModel} from "@shared/models/dialog.model";
import {BehaviorSubject, Subject} from "rxjs";
import {FieldDefinition} from "@shared/models/field-definition";
import {getCurrentProject, ProjectState} from "../../../../../../projects/store/reducers/projects.reducer";
import {select, Store} from "@ngrx/store";
import {takeUntil} from "rxjs/operators";
import {ActivityFilterService} from "../../../../services/activity-filter.service";
import {entityChartRoutes} from "../../../../../../footprint/entity-chart/entity-chart.routes";

@Component({
    standalone: false,
    selector: 'particle-activity-filter-entity-selector',
  templateUrl: './activity-filter-entity-selector.component.html',
  styleUrls: ['./activity-filter-entity-selector.component.scss']
})
export class ActivityFilterEntitySelectorComponent implements OnInit, OnDestroy {
  data: DialogModel;
  fieldDefs: any[] = [];
  selectedItems: any[] = [];
  selectedEntities: any[] = [];
  itemsLeft$: BehaviorSubject<any[]> = new BehaviorSubject([]);
  itemsRight$: BehaviorSubject<any[]> = new BehaviorSubject([]);
  fieldDefs$: BehaviorSubject<FieldDefinition[]> = new BehaviorSubject([]);
  private unsubscribe$ = new Subject<void>();
  valueChanged: boolean = false;
  allRecords: boolean = false;
  private allEntities: any[] = [];

  constructor(private activityFilterService: ActivityFilterService) {
  }

  ngOnInit() {
    this.selectedItems = this.data.input.selectedItems;
    this.allRecords = this.data.input.allRecords;
    if(!this.selectedItems) {
      this.selectedItems = [];
    }
    this.fieldDefs = this.getFieldDefinitions();
    this.fieldDefs$.pipe(takeUntil(this.unsubscribe$));
    this.itemsLeft$.pipe(takeUntil(this.unsubscribe$));
    this.itemsRight$.pipe(takeUntil(this.unsubscribe$));
    this.fieldDefs$.next(this.fieldDefs);
    this.getEntities();
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  onValueChange(event) {
    //console.log('selected entities:', event);
    this.selectedEntities = event.right;
    this.valueChanged = true;
    //console.log('selected ids:', this.selectedItems);
  }

  onOkClicked(): boolean {
    //console.log('[all entities count] ', this.allEntities.length, this.selectedItems.length);
    if(this.allRecords && !this.valueChanged) {
      this.data.input.selectedItems = this.allEntities.map(e => e.id);
    } else {
      this.data.input.selectedItems  = this.valueChanged ? this.selectedEntities.map(item => item.id): this.selectedItems;
    }
    this.data.input.allItemsSelected = this.data.input.selectedItems.length === this.allEntities.length;
    return true;
  }

  getFieldDefinitions() {
    return [
      <FieldDefinition>{
        key: 'EntityCode',
        header: 'Entity Code'
      },
      <FieldDefinition>{
        key: 'EntityName',
        header: 'Entity Name'
      },
      <FieldDefinition>{
        key: 'Country',
        header: 'Country'
      },
      <FieldDefinition>{
        key: 'EntityType',
        header: 'Entity Type'
      },
      <FieldDefinition>{
        key: 'TaxYearEnd',
        header: 'TaxYearEnd'
      },
      {
        key: "IsProposedEntity",
        header: "Proposed Entity"
      }
    ];
  }

  private getEntities() {
    this.activityFilterService.getEntities().pipe(takeUntil(this.unsubscribe$)).subscribe(entities => {
      this.allEntities = entities;
      this.selectedItems = this.selectedItems.filter(id => this.allEntities.findIndex(e => e.id === id) !== -1);
      this.processEntities(entities);
      //console.log('[Entities] :',entities);
    });
  }

  private processEntities(entities) {
    let rightEntities: any[] = [];
    let leftentities: any[] = [];
    if(entities && entities.length > 0) {
     entities.forEach(entity => {
       if(this.allRecords || (this.selectedItems && this.selectedItems.indexOf(entity.id) > -1)) {
         rightEntities.push(entity);
       } else {
         leftentities.push(entity);
       }
     });
    }
    this.itemsLeft$.next(leftentities);
    this.itemsRight$.next(rightEntities);
  }
}
